"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const audiences_1 = require("@cfc/audiences");
const common_types_1 = require("@cfc/common-types");
class ContentServiceClient {
    constructor(config) {
        this.config = config;
        if (!config.environment && !config.customEndpoint) {
            throw new Error('ContentServiceClientConfig must have either contain an environment or a customEndpoint');
        }
    }
    getEndpoint() {
        if (this.config.customEndpoint) {
            return this.config.customEndpoint;
        }
        switch (this.config.environment) {
            case common_types_1.CfcEnvironment.PROD:
                return 'https://content.secondstep.org';
            default:
                return `https://content-${this.config.environment}.cfctest.org`;
        }
    }
    static getBaseQueryParams(params) {
        var _a;
        // default to true if not specified
        let isPreview = 'true';
        if (params.isPreview !== undefined) {
            isPreview = params.isPreview ? 'true' : 'false';
        }
        const queryParams = new URLSearchParams({
            queryType: params.queryType,
            isPreview,
            locale: (_a = params.locale) !== null && _a !== void 0 ? _a : 'en-US',
        });
        return queryParams;
    }
    static getContentQueryParams(params) {
        const queryParams = ContentServiceClient.getBaseQueryParams(params);
        if (params.userContext) {
            // base64 encode the user context:
            queryParams.append('userContext', (0, audiences_1.encodeUserContext)(params.userContext));
        }
        return queryParams;
    }
    getContent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.getEndpoint()}/api/v1/content/${params.entryId}?${ContentServiceClient.getContentQueryParams(params)}`);
            if (!response.ok) {
                throw new Error(`Failed to get content: ${response.statusText}`);
            }
            return yield response.json();
        });
    }
    static getUnvariatedContentQueryParams(params) {
        const queryParams = ContentServiceClient.getBaseQueryParams(params);
        if (params.skipCache) {
            queryParams.append('skipCache', 'true');
        }
        return queryParams;
    }
    getUnvariatedContent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.getEndpoint()}/api/v1/content/unvariated/${params.entryId}?${ContentServiceClient.getUnvariatedContentQueryParams(params)}`);
            if (!response.ok) {
                throw new Error(`Failed to get content: ${response.statusText}`);
            }
            return yield response.json();
        });
    }
    buildAllContent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.config.apiKey) {
                throw new Error('ContentServiceClient must be initialized with an apiKey to build content');
            }
            const response = yield fetch(`${this.getEndpoint()}/api/v1/content/build-all`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.config.apiKey,
                },
                body: JSON.stringify(params),
            });
            if (!response.ok) {
                throw new Error(`Failed to build content: ${response.statusText}`);
            }
            return response.body;
        });
    }
}
exports.default = ContentServiceClient;
